import { RestError } from '@azure/core-http';
import { AcceptInvitationResponseDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useMutation } from 'react-query';
import { parseErrorMessage } from '../../core/api/api.context';
import { getEnvironment } from '../../core/env/environment';

export const useMutationAcceptInvitation = () => {
  return useMutation(async (invitationToken: string) => {
    const env = getEnvironment();
    const result = await fetch(`${env.mgmtUrl}/invitations/${invitationToken}/accept`, { method: 'POST' });
    if (result.ok) {
      const dto = await result.json();
      return { result: dto as AcceptInvitationResponseDto };
    } else {
      const error = await result.json();
      console.error('Error accepting invitation', error);
      return { error: parseErrorMessage((error as RestError)?.message || 'Failed to accept invitation') };
    }
  });
};
